import { onMounted, reactive, Ref, ref, UnwrapRef } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import useSort, { Sort } from '@/renderer/components/SpacePage/compositions/useSort';

type PageData = {
  currPage: number;
  pageSize: number;
  total: number;
  pageSizeOptions: Array<any>;
};
type TableData = {
  list: SMH.FileCollectionListData[];
};
type Handler = {
  loading: Ref<boolean>;
  pageData: UnwrapRef<PageData>;
  tableData: UnwrapRef<TableData>;
  columns: Array<any>;
  sort: UnwrapRef<Sort>;
  methods: {
    onCurrentChange: (current: number) => void;
    sortChange: (newSort: Sort) => void;
    switchSort: (columnName: string) => void;
  };
};

const collectedFileTableHandler = (): Handler => {
  const loading = ref(false);
  const pageData = reactive<PageData>({
    currPage: 1,
    pageSize: 10,
    total: 0,
    pageSizeOptions: [], // 值为[]即不显示
  });
  const {
    innerSort,
    tableSort,
    methods: sortMethods,
  } = useSort('fileCollect', {
    sortBy: undefined,
    descending: true,
    sortType: undefined,
  });
  const columns = [
    {
      colKey: 'title',
      title: 'title-title',
      titleDesc: i18n_t('项目名称'),
      sorter: true,
      ellipsis: {
        disabled: true,
      },
      width: 230,
      className: 'col-project-name',
    },
    {
      colKey: 'dynamic',
      title: i18n_t('动态'),
      width: 350,
    },
    {
      colKey: 'status',
      cell: 'status',
      title: i18n_t('状态'),
      fixed: 'right',
      width: 250,
    },
  ];
  const tableData = reactive<TableData>({
    list: [],
  });
  onMounted(() => {
    methods.pullList();
  });
  const methods = {
    async pullList() {
      const opt = {
        page: pageData.currPage,
        pageSize: pageData.pageSize,
        orderBy: innerSort.value.orderBy,
        orderByType: innerSort.value.orderByType,
        sortType: innerSort.value.sortType ? 'union' : undefined,
      };
      try {
        loading.value = true;
        const { data } = await smh.userAPI.getReceivedFileCollectionList(opt);
        pageData.total = data.totalNum;
        tableData.list = data.contents;
        loading.value = false;
      } catch (e) {
        tips.error(e as MsgError);
      }
    },
    onCurrentChange(current: number) {
      pageData.currPage = current;
      methods.pullList();
    },
    switchSort(columnName: string) {
      // 升序→降序→无序→升序......
      methods.sortChange(sortMethods.switchSort(columnName));
    },
    sortChange(newSort: Sort | undefined) {
      sortMethods.sortChange(newSort);
      methods.pullList();
    },
  };
  return {
    sort: tableSort,
    pageData,
    tableData,
    loading,
    columns,
    methods,
  };
};
export default collectedFileTableHandler;
